// GA4 Web stream "Goal Guru Website" (stream ID 15423344162), goalguru.live
const GA_MEASUREMENT_ID = "G-JY3GLTEJ28";

let isInitialized = false;
let lastTrackedPath: string | null = null;

function isConfigured() {
  return /^G-[A-Z0-9]+$/.test(GA_MEASUREMENT_ID) && !GA_MEASUREMENT_ID.includes("XXXX");
}

/**
 * Load gtag.js and configure GA4 (call after user consent).
 * The script is injected here rather than index.html so nothing
 * is loaded for users who decline.
 */
export function initGoogleAnalytics() {
  if (isInitialized || !isConfigured()) return;

  try {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.gtag = function gtag() {
      w.dataLayer.push(arguments);
    };
    w.gtag("js", new Date());
    // send_page_view: false — page views are sent via trackGaPageView so
    // SPA route changes and the initial load go through one deduped path.
    w.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
    isInitialized = true;

    trackGaPageView(window.location.pathname);
  } catch (e) {
    console.warn("Google Analytics init failed:", e);
  }
}

export function trackGaPageView(path: string) {
  if (!isInitialized) return;
  if (path === lastTrackedPath) return; // dedupe init + RouteTracker overlap
  lastTrackedPath = path;

  try {
    (window as any).gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  } catch (e) {
    console.warn("Google Analytics page view failed:", e);
  }
}
